import { Buffer } from "buffer";
import invariant from "tiny-invariant";

import { generateDeterministicPrivateKey } from "./generate-private-key";
import { getBiometry } from "./get-biometry";

export const getPrivateKey = async (userId: number) => {
  const { biometry } = await getBiometry();

  // invariant(granted, "User has not authorized the use of biometrics");

  invariant(
    biometry.authenticate.isSupported(),
    "biometry.authenticate is not supported"
  );

  const { status, token } = await biometry.authenticate({
    reason: "Access your private key",
  });

  console.log("status, token: ", status, token);
  invariant(
    status === "authorized",
    "biometry.authenticate has failed and returned empty token"
  );

  if (!token) {
    const newToken = await generateDeterministicPrivateKey(userId);
    invariant(
      biometry.updateToken.isSupported() && biometry.updateToken.isAvailable(),
      "biometry.updateToken is not supported or available"
    );
    await biometry.updateToken({
      reason: "Create private token",
      token: Buffer.from(newToken).toString("hex"),
    });

    const { token } = await biometry.authenticate({
      reason: "Access your private key",
    });

    invariant(token, "Something went wrong. token doesn't exists");

    return token;
  }

  return token;
};
